import "./index.css";
import React from "react";
import { AuthContext } from "../../../context/auth";
import simulatedsService from "../../../services/simulateds.service";
import userService from "../../../services/user.service";
import { Helmet } from "react-helmet-async";
import { useState, useEffect, useContext, useRef, useCallback } from "react";
import PendingSimulatedAction from "./PendingSimulatedAction";
import CompletedSimulatedList from "./CompletedSimulatedList";
import Comment from "./Comment";
import { Rating } from "react-simple-star-rating";
import AdSenseMain from "../../../components/AdSenseMain";
import BlogAd from "../../../components/BlogAd";

function Main() {
    const auth = useContext(AuthContext);
    const canonicalURL = 'https://app.simulado.digital';
    const [isLoadingSimulateds, setIsLoadingSimulateds] = useState(true);
    const [isLoadingMore, setIsLoadingMore] = useState(false);
    const [simulateds, setSimulateds] = useState();
    const [offset, setOffset] = useState(0);
    const [hasMore, setHasMore] = useState(true);
    const [rate, setRate] = useState(0);
    const [isRating, setIsRating] = useState(false);
    const [CommentShow, setCommentShow] = useState(false);
    const loaderRef = useRef(null);

    useEffect(() => {
        const loadSimulateds = async () => {
            let response = await simulatedsService.getAll(0, 5);
            if (response.status === 'success') {
                setSimulateds(response.data);
                setOffset(5);
                setHasMore(response.data.length === 5);
                setIsLoadingSimulateds(false);
            }
            if (response.status === 'error') {
                if (response.error === 'invalid token') {
                    auth.setIsLoggedIn(false);
                }
            }
        };
        loadSimulateds();
    }, [auth]);

    useEffect(() => {
        const checkRating = async () => {
            try {
                let checkRatingService = await userService.checkRating();
                if (checkRatingService.status === 'success') {
                    if (checkRatingService.rate > 0) {
                        setIsRating(true);
                        setRate(checkRatingService.rate);
                    } else {
                        setIsRating(false);
                        setRate(0);
                    }
                    setIsRating(checkRatingService.rate);
                }
                if (checkRatingService.status === 'error') {
                    setIsRating(false);
                }
            } catch (error) {
                console.log(error);
            }
        }
        checkRating();
    }, []);

    const handleRating = async (rate) => {
        setRate(rate);
        setCommentShow(true);
    }

    const loadMore = useCallback(async () => {
        setIsLoadingMore(true);
        let response = await simulatedsService.getAll(offset, 5);
        if (response.status === 'success') {
            setSimulateds(prev => [...prev, ...response.data]);
            setOffset(prev => prev + 5);
            setHasMore(response.data.length === 5);
        }
        if (response.status === 'error') {
            if (response.error === 'invalid token') {
                auth.setIsLoggedIn(false);
            }
        }
        setIsLoadingMore(false);
    }, [auth, offset]);

    useEffect(() => {
        const loaderNode = loaderRef.current;
        const observer = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting && hasMore && !isLoadingMore) {
                loadMore();
            }
        });

        if (loaderNode) {
            observer.observe(loaderNode);
        }

        return () => {
            if (loaderNode) {
                observer.unobserve(loaderNode);
            }
        };
    }, [hasMore, isLoadingMore, loadMore]);

    return (
        <>
            <Helmet>
                <link rel="canonical" href={canonicalURL} />
            </Helmet>
            <div className="container-fluid p-3 p-md-4 overflow-hidden">
                <h2 className="m-0">Meus simulados</h2>
                <PendingSimulatedAction />
                {
                    !isLoadingSimulateds && Array.isArray(simulateds) && simulateds.length > 0 && (
                        <div className="rating-container mb-5">
                            <div className="rating-legend">
                                {
                                    isRating ? "Avaliado:" : "Avaliar:"
                                }
                            </div>
                            <Rating
                                initialValue={rate}
                                onClick={handleRating}
                                readonly={isRating}
                                size={30}
                                tooltipDefaultText='Avaliar'
                            />
                            <Comment
                                isRating={() => setIsRating(true)}
                                onHide={() => setCommentShow(false)}
                                rate={rate}
                                setRate={(rate) => setRate(rate)}
                                show={CommentShow}                            
                            />
                        </div>
                    )
                }
                {
                    !isLoadingSimulateds && (
                        <AdSenseMain />
                    )
                }
                <BlogAd />
                <CompletedSimulatedList
                    simulateds={simulateds}
                    isLoading={isLoadingSimulateds}
                />
                {
                    !isLoadingSimulateds && isLoadingMore && (
                        <div className="container-spinner-more-simulateds text-center p-3">
                            <span className="spinner-grow spinner-border-sm text-primary"></span>
                        </div>
                    )
                }
                {
                    !isLoadingSimulateds && hasMore && (
                        <div ref={loaderRef} style={{height: '10px'}}></div>
                    )
                }
            </div>
        </>
    );
}

export default Main;
